import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCircle} from '@fortawesome/free-solid-svg-icons'

export function PanelDots(props) {
  return (
    Array(props.count).fill(0).map ((item, index) =>
      <span key={"dot"+index} style={{ paddingRight: '1em' }} onClick={props.onClick}>
        <FontAwesomeIcon icon={faCircle} color={index===props.selected?"#18BC9C":"gray"} key={index} className="fa-xs"/>
      </span>
    )
  )
}
